module.exports = __webpack_public_path__ + "static/media/choice-button-modal-1.4b113d1f.webp";